import axios from "axios";

// Default backend configuration for local development
const LOCAL_BACKEND_CTX = {
  PROTOCOL: "http://",
  HOST: "localhost",
  PORT: ":9090",
  POSTFIX: ""
};

// Determine the backend host based on the environment
let backendHost;
if (window.location.hostname === "localhost") {
  backendHost = LOCAL_BACKEND_CTX.HOST;
} else {
  backendHost = window.location.hostname;
}

// Backend configuration
const backendConfig = {
  PROTOCOL: "https://",
  HOST: "assessmyrisks.com",
  PORT: "",
  POSTFIX: ""
};

// To use local host within inter-WiFi uncomment the below
// const backendConfig = {
//   PROTOCOL: "http://",
//   HOST: backendHost,
//   PORT: ":9090",
//   POSTFIX: ""
// };

// Construct backend URL
// this helps to access the application with in the network(Wifi/Local network), 
// when both UI and Backend runs locally in the same machine locally
const LOCAL_REST_API_BACKEND = backendConfig.PROTOCOL + backendConfig.HOST + backendConfig.PORT + backendConfig.POSTFIX;

const REST_API = {
  LOGIN: LOCAL_REST_API_BACKEND + "/api/auth/login",
  LOGOUT: LOCAL_REST_API_BACKEND + "/api/auth/logout",
  USERS: LOCAL_REST_API_BACKEND + "/api/users",
  SITES: LOCAL_REST_API_BACKEND + "/api/sites",
  SECTIONS: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/sections",
  FIELDS: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/fields",
  FIELD: LOCAL_REST_API_BACKEND + "/api/fields",
  LINKS: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/links",
  LINK: LOCAL_REST_API_BACKEND + "/api/links",
  LABELS: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/labels",
  SITES_FOR_REPORT: LOCAL_REST_API_BACKEND + "/api/sites/sites-for-report",
  SITE_SECTIONS_REORDER: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/sections/reorder",
  SITE_SECTIONS_QUESTIONS_REORDER: LOCAL_REST_API_BACKEND + "/api/sections/:sectionid/questions/reorder",
  SITE_FIELDS_REORDER: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/fields/reorder",
  SITE_LINKS_REORDER: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/links/reorder",
  LABEL: LOCAL_REST_API_BACKEND + "/api/labels",
  SECTION: LOCAL_REST_API_BACKEND + "/api/sections",
  USER_PROFILE_RESET_PASSWORD: LOCAL_REST_API_BACKEND + "/bulkresetpassword",
  RESET_PASSWORD: LOCAL_REST_API_BACKEND + "/api/auth/resetpassword",
  USER_RESET_PASSWORD: LOCAL_REST_API_BACKEND + "/api/auth/userresetpassword",
  QUESTIONS: LOCAL_REST_API_BACKEND + "/api/sections/:sectionid/questions",
  QUESTION: LOCAL_REST_API_BACKEND + "/api/questions",
  INCOMPLETEREPORTS: LOCAL_REST_API_BACKEND + "/api/report/registration/incomplete/:siteid",
  COMPLETEREPORTS: LOCAL_REST_API_BACKEND + "/api/report/registration/complete/:siteid",
  EXPORTINCOMPLETEREPORTS: LOCAL_REST_API_BACKEND + "/api/report/export/registration/incomplete/:siteid",
  EXPORTCOMPLETEREPORTS: LOCAL_REST_API_BACKEND + "/api/report/export/registration/complete/:siteid",
  PDFREPORT: LOCAL_REST_API_BACKEND + "/api/report/registration/pdf/:id",
  PROJECTS: LOCAL_REST_API_BACKEND + "/api/project",
  PROJECT_SITES: LOCAL_REST_API_BACKEND + "/api/sites/project/:projectid",
  MOVE_SITES: LOCAL_REST_API_BACKEND + "/api/sites/move/:siteid",
  QUESTIONS_PER_SITE: LOCAL_REST_API_BACKEND + "/api/sites/:siteid/questions",
  GLOBAL_REPORT_DASHBOARD: LOCAL_REST_API_BACKEND + "/api/report/assessments",
  SCORE_RANGE: LOCAL_REST_API_BACKEND + "/api/score-ranges",
};

const APP_URL_PREFIX = "/internal";

let APP_URLS = {
  LOGIN_PAGE: APP_URL_PREFIX + "/login",
  RESET_PASSWORD_PAGE: APP_URL_PREFIX + "/resetpassword",
  LANDING_PAGE: APP_URL_PREFIX + "/",
  USERS_PAGE: APP_URL_PREFIX + "/users",
  SETTINGS_PAGE: APP_URL_PREFIX + "/settings",

  // new app url for risk360
  // SITES_PAGE: APP_URL_PREFIX + "/sites",
  DYNAMIC_SITES_PAGE: APP_URL_PREFIX + "/sites/",
  // ADD_SITE_PAGE: APP_URL_PREFIX + "/sites/addsite",
  PROJECT_EDIT_SITE_PAGE: APP_URL_PREFIX + "/project/:projectid/editsite/:siteid",
  EDIT_SITE_PAGE: APP_URL_PREFIX + "/editsite/:siteid",
  SITE_PAGE: APP_URL_PREFIX + "/site/:siteid",
  PROJECT_SITE_PAGE: APP_URL_PREFIX + "/project/:projectid/site/:siteid",
  SECTION_PAGE: APP_URL_PREFIX + "/site/:siteid/section/:sectionid",
  PROJECT_SECTION_PAGE: APP_URL_PREFIX + "/project/:projectid/site/:siteid/section/:sectionid",
  SITE_REPORTS_PAGE: APP_URL_PREFIX + "/site-reports",
  PROJECTS_PAGE: APP_URL_PREFIX + "/project",
  GLOBAL_REPORTS_PAGE: APP_URL_PREFIX + "/global-reports",
};

APP_URLS.SITE_SECTIONS = APP_URLS.SITE_PAGE + "/sections";
APP_URLS.PROJECT_SITE_SECTIONS = APP_URLS.PROJECT_SITE_PAGE + "/sections"
APP_URLS.SITE_FIELDS = APP_URLS.SITE_PAGE + "/fields";
APP_URLS.PROJECT_SITE_FIELDS = APP_URLS.PROJECT_SITE_PAGE + "/fields";
APP_URLS.SITE_LABELS = APP_URLS.SITE_PAGE + "/labels";
APP_URLS.PROJECT_SITE_LABELS = APP_URLS.PROJECT_SITE_PAGE + "/labels";
APP_URLS.SITE_REPORTS = APP_URLS.SITE_PAGE + "/reports";
APP_URLS.PROJECT_SITE_REPORTS = APP_URLS.PROJECT_SITE_PAGE + "/reports";
APP_URLS.SITE_LINKS = APP_URLS.SITE_PAGE + "/links";
APP_URLS.PROJECT_SITE_LINKS = APP_URLS.PROJECT_SITE_PAGE + "/links";
APP_URLS.PROJECT_SITE_RANGE = APP_URLS.PROJECT_SITE_PAGE + "/range";


const NAV_ITEMS_KEYS = [
  // new nav items for risk360
  // "sites",
  "users",
  "settings",
  "reports",
  "globalReports",
];

const NAV_ITEMS_VALUES = {
  // sites: {
  //   title: "Sites",
  //   url: APP_URLS.SITES_PAGE,
  //   enabled: true,
  // },
  users: {
    title: "Users",
    url: APP_URLS.USERS_PAGE,
    enabled: false,
    persona: "admin",
  },
  settings: {
    title: "Settings",
    url: APP_URLS.SETTINGS_PAGE,
    enabled: true,
  },
  reports: {
    title: "Site Reports",
    url: APP_URLS.SITE_REPORTS_PAGE,
    enabled: true,
    //  persona: "admin",
  },
  globalReports: {
    title: "Global Reports",
    url: APP_URLS.GLOBAL_REPORTS_PAGE,
    enabled: true,
    persona: "admin",
  }
};

const SITE_NAV_ITEMS_KEYS = [
  "sections",
  "labels",
  "fields",
  "reports",
  "links",
  "range"
];

const SITE_NAV_ITEMS_VALUES = {
  sections: {
    title: "Sections",
    url: APP_URLS.SITE_SECTIONS,
    enabled: true,
  },
  labels: {
    title: "Labels",
    url: APP_URLS.SITE_LABELS,
    enabled: true,
  },
  fields: {
    title: "Fields",
    url: APP_URLS.SITE_FIELDS,
    enabled: true,
  },
  reports: {
    title: "Reports",
    url: APP_URLS.SITE_REPORTS,
    enabled: true
  },
  links: {
    title: "Links",
    url: APP_URLS.SITE_LINKS,
    enabled: true
  }
};

const PROJECT_SITE_NAV_ITEMS_VALUES = {
  sections: {
    title: "Sections",
    url: APP_URLS.PROJECT_SITE_SECTIONS,
    enabled: true,
  },
  labels: {
    title: "Labels",
    url: APP_URLS.PROJECT_SITE_LABELS,
    enabled: true,
  },
  fields: {
    title: "Fields",
    url: APP_URLS.PROJECT_SITE_FIELDS,
    enabled: true,
  },
  reports: {
    title: "Reports",
    url: APP_URLS.PROJECT_SITE_REPORTS,
    enabled: true
  },
  links: {
    title: "Links",
    url: APP_URLS.PROJECT_SITE_LINKS,
    enabled: true
  },
  range: {
    title: "Range",
    url: APP_URLS.PROJECT_SITE_RANGE,
    enabled: true
  }
};



const ADMIN_PAGE_ROUTING_VARIABLE = 'internal';

const APP_CONSTANTS = {
  DOUBLE_TICK: "double_tick",
  QUIZ_PAGE_URL: "https://spottherisk.com/",
  SURVEY_PAGE_URL: "https://assessmyrisks.com/",
};

const LOCAL_STORAGE = window.localStorage;
const STORAGE = LOCAL_STORAGE;

const TTL = 1800000;
const LONG_TTL = 180000000;

const SESSION = "risk360_session";
const TOKEN = "accessToken";
const EMAIL = "email";
const USERID = "id";
const QUIZ_SURVEY_MAP = "quizSurveyMap";
const UPDATED_VIEW_MAP = "updatedViewMap";

const STATUS_OK = 200;
//Declaration of variables for the export of site report
const ReportVariables = {
  Incomplete: "incomplete",
  Complete: "complete"
};

const userSessionExists = () => {
  let sessionExists = !isObjectEmpty(getSession());
  return !!sessionExists;
};

const createSession = (userObj) => {
  let storageObj = {};
  storageObj[TOKEN] = userObj.accessToken;
  storageObj[EMAIL] = userObj?.user?.email || "";
  storageObj[USERID] = userObj?.user?.id || "";
  // Hardcoded map key for storing UUIDs or any other map
  storageObj[QUIZ_SURVEY_MAP] = {};
  storageObj[UPDATED_VIEW_MAP] = {};

  const now = new Date();

  const storageValue = {
    value: storageObj,
    expiry: now.getTime() + (userObj.rememberMe ? LONG_TTL : TTL),
  };

  STORAGE.setItem(SESSION, JSON.stringify(storageValue));
};

const deleteSession = (info) => {
  STORAGE.removeItem(SESSION);
};

const getSession = () => {
  const itemStr = STORAGE.getItem(SESSION);
  if (!itemStr) {
    return {};
  }
  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    STORAGE.removeItem(SESSION);
    return {};
  }
  return item.value;

  // let session = JSON.parse(STORAGE.getItem(SESSION)) || {};
  // return session;
};

const getToken = (session = getSession()) => {
  let token = session[TOKEN] || "";
  return token.length ? "Bearer " + token : "";
};

const getUserEmail = (session = getSession()) => {
  let token = session[EMAIL] || "";
  return token;
};

const getUserId = (session = getSession()) => {
  let token = session[USERID] || "";
  return token;
};

const getSpecSessionValue = (session = getSession(), sessionkey) => {
  let value = session[sessionkey] || "";
  return value;
};

const isObjectEmpty = (obj = {}) => {
  return Object.keys(obj).length === 0;
};

const setSiteMapValue = (mapKey, uuid, value) => {

  if (!uuid) return;

  const session = getSession();

  if (!session[mapKey]) {
    session[mapKey] = {};
  }

  session[mapKey][uuid] = !!value;

  // Save updated session back with the same expiry as before
  const now = new Date();

  const existingExpiry = STORAGE.getItem(SESSION)
    ? JSON.parse(STORAGE.getItem(SESSION)).expiry
    : now.getTime() + TTL;

  const storageValue = {
    value: session,
    expiry: existingExpiry,
  };
  STORAGE.setItem(SESSION, JSON.stringify(storageValue));
};

const setQuizSurveyMapValue = (uuid, value) => {
  setSiteMapValue(QUIZ_SURVEY_MAP, uuid, value);
};

const getQuizSurveyMapValue = (uuid) => {
  if (!uuid) return false;

  const session = getSession();
  return !!session[QUIZ_SURVEY_MAP]?.[uuid];
};

const setUpdatedViewMapValue = (uuid, value) => {
  setSiteMapValue(UPDATED_VIEW_MAP, uuid, value);
};

const getUpdatedViewMapValue = (uuid) => {
  if (!uuid) return false;

  const session = getSession();
  return !!session[UPDATED_VIEW_MAP]?.[uuid];
};

const getAllUsers = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.USERS;
      // console.log("getUrl::::::", getUrl);
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const getLanguages = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.LANGUAGES;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const bulkUsersUpload = (userData) => {
  let formData = { ...userData };
  delete formData.id;
  let url = REST_API.USER_BULK_UPLOAD;
  return axios({
    method: "post",
    url: url,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const addUser = (userData) => {
  let formData = { ...userData };
  delete formData.id;
  let url = REST_API.USERS;

  return axios.post(url, formData);
};

const editUser = (userData, userId) => {
  let formData = { ...userData };
  console.log("formData::::", formData);
  delete formData.id;
  let url = REST_API.USERS + "/" + userId;

  // return axios.patch(url, formData);
  return executeRestApi(url, "patch", formData);
};

const getAllUserProfiles = (userId) => {
  let url = REST_API.USER_PROFILE + userId;
  let session = getSession();
  if (isObjectEmpty(session).length === 0) {
    console.log("No session established!")
  }

  let token = getToken();

  if (token) {
    return axios
      .get(url, {
        headers: {
          Authorization: `${token}`,
        },
      })
  }

  return axios.get(url);
};

const createProfile = (userData) => {
  let formData = { ...userData };
  delete formData.id;
  let url = REST_API.USER_PROFILE;

  return axios.post(url, formData);
};

const editUserProfile = (userData, url) => {
  let formData = { ...userData };
  delete formData.id;
  return axios.patch(url, formData);
};

const editProfile = (userData, userProfileId) => {
  let url = REST_API.USER_PROFILE + userProfileId;
  return editUserProfile(userData, url);
};

const editMasterProfile = (userData, userId) => {
  let url = REST_API.EDIT_USER_PROFILE + userId;
  return editUserProfile(userData, url);
};

const deleteProfile = (userProfile) => {
  // let formData = { ...userData };
  // delete formData.id;
  let url = REST_API.USER_PROFILE + userProfile.id;

  return axios.delete(url);
};

const deleteUser = (userId) => {
  let url = REST_API.USERS + "/" + userId;
  console.log("delete url:::::::", url);
  return axios.delete(url);
};

const resetPasswordUsers = (usersArray) => {
  let formData = { userIds: [...usersArray] };
  let url = REST_API.RESET_PASSWORD;

  return axios.post(url, formData);
};

const deleteUsers = (usersArray) => {
  let promises = [];
  usersArray.forEach((badge) => {
    promises.push(deleteUser(badge));
  });

  return Promise.all(usersArray);
};

const getFilteredUsers = (filterKey, filterQuery) => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.USERS + filterKey + "/" + filterQuery;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const downloadQRCode = (publicId, size) => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.DOWNLOAD_QRCODE + publicId + "/" + size;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch(function (error) {
          console.log(error.response.status);
          console.log(error.response.data.error);
          if (error.response.status === 401) {
            reject({
              redirect: true,
              error,
            });
          }
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const getUserCardsList = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.USER_CARD;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch(function (error) {
          console.log(error.response.status);
          console.log(error.response.data.error);
          if (error.response.status === 401) {
            reject({
              redirect: true,
              error,
            });
          }
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const addBrand = (addressData) => {
  let formData = { ...addressData };
  delete formData.id;
  let url = REST_API.BRANDS;

  return axios.post(url, formData);
};

const getBrands = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.BRANDS;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const deleteBrand = (brandId) => {
  let url = REST_API.BRANDS;
  return axios.delete(url + brandId);
};

const deleteBrands = (brandsArray) => {
  let promises = [];
  brandsArray.forEach((brand) => {
    promises.push(deleteBrand(brand));
  });
  return Promise.all(brandsArray);
};

const getAddresses = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.ADDRESSES;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const deleteAddress = (addressUID) => {
  let url = REST_API.ADDRESSES;
  return axios.delete(url + addressUID);
};

const deleteAddresses = (addressesArray) => {
  let promises = [];
  addressesArray.forEach((address) => {
    promises.push(deleteAddress(address));
  });

  return Promise.all(addressesArray);
};

const bulkAddressUpload = (addressData) => {
  let formData = { ...addressData };
  delete formData.id;
  let url = REST_API.ADDRESS_BULK_UPLOAD;
  return axios({
    method: "post",
    url: url,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const addAddress = (addressData) => {
  let formData = { ...addressData };
  delete formData.id;
  let url = REST_API.ADDRESSES;

  return axios.post(url, formData);
};

const editAddress = (addressData, addressId) => {
  let formData = { ...addressData };
  delete formData.id;
  let url = REST_API.ADDRESSES + addressId;

  return axios.patch(url, formData);
};

const addBadge = (badgeData) => {
  let formData = { ...badgeData };
  delete formData.id;
  let url = REST_API.BADGES;

  return axios.post(url, formData);
};

const editBadge = (badgeData, badgeId) => {
  let formData = { ...badgeData };
  delete formData.id;
  let url = REST_API.BADGES + badgeId;

  return axios.patch(url, formData);
};

const deleteBadge = (badgeUID) => {
  let url = REST_API.BADGES;
  return axios.delete(url + badgeUID);
};

const deleteBadges = (badgesArray) => {
  let promises = [];
  badgesArray.forEach((badge) => {
    promises.push(deleteBadge(badge));
  });

  return Promise.all(badgesArray);
};

const getBadges = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.BADGES;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const getUserProfile = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let userId = getUserId(session);
      let getUrl = REST_API.USERS + "/" + userId;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          let code = error?.response?.status ?? 200;
          reject({
            redirect: true,
            message: "No token available till now...",
          });
        })
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const addNewTemplate = (templateData) => {
  let formData = { ...templateData };
  delete formData.id;
  let url = REST_API.TEMPLATES;

  return axios.post(url, formData);
};

const editTemplate = (templateId, templateData) => {
  let formData = { ...templateData };
  delete formData.id;
  let url = REST_API.TEMPLATES + "/" + templateId;

  return axios.patch(url, formData);
};

const deleteTemplate = (templateId) => {
  let url = REST_API.TEMPLATES + "/" + templateId;

  return axios.delete(url);
};

const getTemplates = () => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.TEMPLATES;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const getSiteDetailsbyId = (siteId) => {
  let url = REST_API.SITES + "/" + siteId;

  return executeRestApi(url, "get");
}

const getTemplateDetails = (templateId) => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.TEMPLATES + "/" + templateId;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const getCardDetailsAsAnonymous = async (cardPublicId) => {
  const myPromise = new Promise((resolve, reject) => {
    let getUrl = REST_API.ANONYMOUS_CARD + "/" + cardPublicId;
    try {
      axios
        .get(getUrl, {
          validateStatus: (status, res) => {
            if (status === 404) {
              reject({
                redirect: true,
                message: "No such card exists!",
              });
            } else {
              //console.log(" card exists ");
            }
            return true;
          },
        })
        .then((res) => {
          resolve(res);
        });
    } catch (err) {
      reject({
        redirect: true,
        message: "No such card exists!",
      });
    }
  });

  return myPromise;
};

const getAddressAsAnonymous = (addrId) => {
  const myPromise = new Promise((resolve, reject) => {
    let getUrl = REST_API.ANONYMOUS_ADDRESS + "/" + addrId;
    axios.get(getUrl).then((res) => {
      resolve(res);
    });
  });

  return myPromise;
};

const getCardDetails = (cardId) => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.USER_CARD + "/" + cardId;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const validateCardFriendlyId = (cardFriendlyId) => {
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let getUrl = REST_API.VERIFY_USER_CARD + cardFriendlyId;
      axios
        .get(getUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const deleteCard = (cardId) => {
  let dataCardId = parseInt(cardId, 10);
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let deleteUrl = REST_API.USER_CARD + "/" + dataCardId;
      axios
        .delete(deleteUrl, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const executeLogoutRESTAPI = () => {
  const alwaysClassback = (response, callbackFn) => {
    deleteSession();
    if (response.status === STATUS_OK) {
    }
    callbackFn({
      redirect: true,
      ...{ response },
    });
  };
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();

    let formData = {};
    let logoutUrl = REST_API.LOGOUT;
    let success = (response) => {
      alwaysClassback(response, resolve);
    };
    let failure = (err) => {
      alwaysClassback(err.response, reject);
    };
    try {
      axios
        .post(logoutUrl, formData, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then(success, failure);
    } catch (e) {
      console.log(e);
    }
  });

  return myPromise;
};

const executeLoginRESTAPI = (params) => {
  const myPromise = new Promise((resolve, reject) => {
    let formData = {
      email: params.email,
      password: params.userPwd,
    };
    // let headersInfo = {
    //   headers: {
    //     "Content-type": "application/json",
    //   },
    // };
    let loginUrl = REST_API.LOGIN;

    let success = (res) => {
      let returnObject = {
        redirect: true,
        redirectToResetPwd: false,
        ...res,
      };
      if (res.status === STATUS_OK) {
        deleteSession();
        createSession({ ...res.data, rememberMe: params.rememberMe });
        if (!!res.data.user) {
        } else {
          returnObject.redirectToResetPwd = true;
        }
      }
      resolve(returnObject);
    };

    let failure = (err) => {
      resolve({
        redirect: false,
        ...err.response,
      });
    };
    axios.post(loginUrl, formData /*, headersInfo*/).then(success, failure);
  });

  return myPromise;
};

const executeResetPassword = (params) => {
  let formData = {
    newpassword: params.newpassword,
    confirmpassword: params.confirmpassword,
  };

  let resetUrl = REST_API.RESET_PASSWORD;
  return executeRestApi(resetUrl, "post", formData);
};

const executeUserResetPassword = (formInfo) => {
  let formData = { ...formInfo };
  let url = REST_API.USER_RESET_PASSWORD;

  return axios.post(url, formData);
};

const executeCardAddRESTAPI = (cardData) => {
  let formData = { ...cardData };
  delete formData.id;
  let url = REST_API.USER_CARD;

  return axios.post(url, formData);
};

const executeCardEditRESTAPI = (cardData, cardId) => {
  let formData = { ...cardData };
  delete formData.id;
  let url = REST_API.USER_CARD + "/" + cardId;

  return axios.patch(url, formData);
};

const addOrRemoveCardFromUser = (userCardsArray) => {
  let formData = { cards: userCardsArray };
  delete formData.id;
  let url = REST_API.USERS + getUserId();
  return axios.patch(url, formData);
};

const cardMail = (mailData) => {
  let formData = { ...mailData };
  let url = REST_API.CARD_MAIL;

  let token = getToken();
  if (token) {
    return axios.post(url, formData, {
      headers: {
        Authorization: `${token}`,
      },
    });
  } else {
    console.error("No token available till now...");
  }

  //return axios.(url, formData);
};


//Folder API call
const getAllFolders = () => {
  let url = REST_API.PROJECTS;
  return executeRestApi(url, "get");
};

const addFolder = (projectId, folderName) => {
  let url = REST_API.PROJECTS;
  let formData = {
    name: folderName,
    parentId: projectId === VIRTUAL_FOLDER_NAME ? null : projectId
  };
  return executeRestApi(url, "post", formData);
};

const editFolder = (projectId, parentId, folderName) => {
  let url = REST_API.PROJECTS + "/" + projectId;
  let formData = { name: folderName, parentId: parentId };
  return executeRestApi(url, "patch", formData);
};

const deleteFolder = (projectId) => {
  let url = REST_API.PROJECTS + "/" + projectId;
  return executeRestApi(url, "delete", {});
}

const getProjectSites = (projectId) => {
  let url = REST_API.PROJECT_SITES.replace(":projectid", projectId);
  return executeRestApi(url, "get");
};

const getAllSites = () => {
  let url = REST_API.SITES;

  return executeRestApi(url, "get");
};

const getRootLevelSites = () => {
  let url = REST_API.SITES + "/root";

  return executeRestApi(url, "get");
};

const getAllSitesForReport = () => {
  let url = REST_API.SITES_FOR_REPORT;
  return executeRestApi(url, "get");
};

const cloneSite = (siteId, formData) => {

  let url = REST_API.SITES + "/clone/" + siteId;
  return executeRestApi(url, "post", formData);
}

const updateSite = (siteId, formData) => {

  let url = REST_API.SITES + "/" + siteId;
  return executeRestApi(url, "patch", formData);
}

const moveSite = (siteId, projectId) => {
  let url = REST_API.MOVE_SITES.replace(":siteid", siteId);
  let formData = { projectId: projectId };
  return executeRestApi(url, "patch", formData);
};

const moveSites = (siteIds, projectId) => {
  const promises = siteIds.map((siteId) => moveSite(siteId, projectId));
  return Promise.all(promises);
};


const deleteSite = (siteId) => {
  let url = REST_API.SITES + '/' + siteId;

  return executeRestApi(url, "delete", {});
};

const deleteSites = (sitesArray) => {
  let promises = [];
  sitesArray.forEach((siteId) => {
    promises.push(deleteSite(siteId));
  });

  return Promise.all(sitesArray);
};

const getAllQuestions = ({ siteId, sectionId }) => {
  let url = REST_API.QUESTIONS.replace(":sectionid", sectionId);

  return executeRestApi(url, "get");
};

const getAllQuestionsForSite = (siteId) => {
  let url = REST_API.QUESTIONS_PER_SITE.replace(":siteid", siteId);

  return executeRestApi(url, "get");
}

const addQuestion = (sectionId, questionformData) => {
  let url = REST_API.QUESTIONS.replace(":sectionid", sectionId);

  return executeRestApi(url, "post", questionformData);
};

const updateQuestion = (questionId, questionformData) => {
  let url = REST_API.QUESTION + '/' + questionId;

  return executeRestApi(url, "patch", questionformData);
};

const deleteQuestion = (questionId) => {
  let url = REST_API.QUESTION + '/' + questionId;

  return executeRestApi(url, "delete", {});
};

const deleteQuestions = (questionArray) => {
  let promises = [];
  questionArray.forEach((questionId) => {
    promises.push(deleteQuestion(questionId));
  });

  return Promise.all(questionArray);
};

const getAllSections = ({ siteId }) => {
  let url = REST_API.SECTIONS.replace(":siteid", siteId);

  return executeRestApi(url, "get");
};

const addSection = (siteId, sectionFormData) => {

  let url = REST_API.SECTIONS.replace(":siteid", siteId);
  return executeRestApi(url, "post", sectionFormData);
};

const updateSection = (sectionId, sectionFormData) => {

  let url = REST_API.SECTION + '/' + sectionId;
  return executeRestApi(url, "patch", sectionFormData);
};

const deleteSection = (sectionId) => {
  let url = REST_API.SECTION + '/' + sectionId;

  return executeRestApi(url, "delete", {});
};

const deleteSections = (sectionArray) => {
  let promises = [];
  sectionArray.forEach((sectionId) => {
    promises.push(deleteSection(sectionId));
  });

  return Promise.all(sectionArray);
};

const getAllFieldsBySitedId = ({ siteId }) => {

  let url = REST_API.FIELDS.replace(":siteid", siteId);

  return executeRestApi(url, "get");
};

const addField = (siteId, fieldFormData) => {

  let url = REST_API.FIELDS.replace(":siteid", siteId);

  return executeRestApi(url, "post", fieldFormData);
};

const updateFieldById = (fieldId, fieldFormData) => {

  let url = REST_API.FIELD + '/' + fieldId;

  return executeRestApi(url, "patch", fieldFormData);
};

const deleteField = (fieldId) => {
  let url = REST_API.FIELD + '/' + fieldId;

  return executeRestApi(url, "delete", {});
};

const deleteFields = (fieldArray) => {
  let promises = [];
  fieldArray.forEach((fieldId) => {
    promises.push(deleteField(fieldId));
  });

  return Promise.all(fieldArray);
};

const getAllLinksBySitedId = ({ siteId }) => {
  let url = REST_API.LINKS.replace(":siteid", siteId);
  return executeRestApi(url, "get");
};

const addLink = (siteId, linkFormData) => {

  let url = REST_API.LINKS.replace(":siteid", siteId);

  return executeRestApi(url, "post", linkFormData);
};

const updateLinkById = (linkId, linkFormData) => {

  let url = REST_API.LINK + '/' + linkId;

  return executeRestApi(url, "patch", linkFormData);
};

const deleteLink = (linkId) => {
  let url = REST_API.LINK + '/' + linkId;

  return executeRestApi(url, "delete", {});
};

const deleteLinks = (linkArray) => {
  let promises = [];
  linkArray.forEach((linkId) => {
    promises.push(deleteLink(linkId));
  });

  return Promise.all(linkArray);
};

const getAllLabelsBySitedId = ({ siteId }) => {

  let url = REST_API.LABELS.replace(":siteid", siteId);
  return executeRestApi(url, "get");
};

const addLabel = (siteId, labelFormData) => {

  let url = REST_API.LABELS.replace(":siteid", siteId);
  return executeRestApi(url, "post", labelFormData);
};

const updateLabel = (labelId, formData) => {

  let url = REST_API.LABEL + '/' + labelId;
  return executeRestApi(url, "patch", formData);
};

const deleteLabel = (labelId) => {
  let url = REST_API.LABEL + '/' + labelId;

  return executeRestApi(url, "delete", {});
};

const deleteLabels = (lableArray) => {
  let promises = [];
  lableArray.forEach((labelId) => {
    promises.push(deleteLabel(labelId));
  });

  return Promise.all(lableArray);
};

const getIncompleteReportsBySiteId = ({ siteId }) => {
  let url = REST_API.INCOMPLETEREPORTS.replace(":siteid", siteId);
  return executeRestApi(url, "get");
};

const getCompleteReportsBySiteId = ({ siteId }) => {
  let url = REST_API.COMPLETEREPORTS.replace(":siteid", siteId);
  return executeRestApi(url, "get");
}

//Pdf download api call
const getPdfReportById = ({ Id }) => {
  let url = REST_API.PDFREPORT.replace(":id", Id);
  return executeRestApi(url, "get", {}, true);
}
//Common method to get the export data of incomplete and complete reports
const getExportReportsBySiteId = ({ siteId, reportType }) => {
  let url;
  if (reportType === ReportVariables.Incomplete) {
    url = REST_API.EXPORTINCOMPLETEREPORTS.replace(":siteid", siteId);
  } else if (reportType === ReportVariables.Complete) {
    url = REST_API.EXPORTCOMPLETEREPORTS.replace(":siteid", siteId);
  }
  return executeRestApi(url, "get");
}

const executeRestApi = (getUrl, type = "get", formData = {}, isPdf = false) => {
  let isMultipart = formData.isMultipart ?? false;
  const myPromise = new Promise((resolve, reject) => {
    let session = getSession();
    if (isObjectEmpty(session).length === 0) {
      reject({
        redirect: true,
        message: "No session establised till now...",
      });
    }

    let token = getToken();
    if (token) {
      let headersObj = {
        Authorization: `${token}`,
      };
      isMultipart &&
        (headersObj = { ...headersObj, "Content-Type": "multipart/form-data" });
      delete formData.isMultipart;

      axios({
        method: type,
        url: getUrl,
        data: formData,
        headers: headersObj,
        ...(isPdf && { responseType: 'blob' })
        // responseType: isPdf ? 'blob' : 'json'
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          let code = error?.response?.status ?? 200;
          // if (error.code === "ERR_NETWORK") {
          //   reject({
          //     redirect: true,
          //     message: "Server Not Available",
          //   });
          // }
          // console.log("error response:::", error.code);
          // console.log("error response:::", error.response);
          // console.log(error?.response?.status);
          // console.log(error.response.data.error);
          reject({
            error,
            redirect: code === 401 || code === 403,
          });
        });
    } else {
      reject({
        redirect: true,
        message: "No token available till now...",
      });
    }
  });

  return myPromise;
};

const handleDefaultError = ({
  error,
  setLoadingState,
  setCanRedirectToLogin,
  setCanRedirectToError,
  errorCode,
}) => {
  // console.log(error.message);
  let errCode = errorCode ?? error?.response?.status ?? 401;
  setLoadingState &&
    setLoadingState({
      applyMask: false,
    });

  // let session = getSession();
  // let tempObj = { ...session, ...{ path: PAGES[0] } };
  // store(tempObj, setPageInfo);

  errCode === 401 && setCanRedirectToLogin && setCanRedirectToLogin(true);
  errCode === 403 && setCanRedirectToError && setCanRedirectToError(true);
};

const guestMail = (mailData) => {
  let formData = { ...mailData };
  let url = REST_API.GUEST_MAIL;

  return axios.post(url, formData);
};

const getUniqueSetOfArray = (arr) => {
  return [...new Set(arr)];
};

const fileToDataUri = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });
};

const getDomainName = () => {
  return backendConfig.PROTOCOL + backendConfig.HOST + backendConfig.PORT;
}

const getImagePath = (imgPath) => {
  const prefix = backendConfig.PROTOCOL + backendConfig.HOST + backendConfig.PORT;
  return prefix + imgPath;
  // return imgPath;
}
const getStaticImagePath = (imgPath) => {
  // const prefix = CTX.PROTOCOL + CTX.HOST + CTX.PORT + "/static/";
  // return prefix + imgPath;
  return imgPath;
}

const saveOrderForSite = ({ siteId, orderObj }) => {
  let url = REST_API.SITE_SECTIONS_REORDER.replace(":siteid", siteId);
  // console.log(url);
  return executeRestApi(url, "post", orderObj);
  // return axios.post(url, orderObj);
};

const saveOrderForSection = ({ sectionId, orderObj }) => {
  let url = REST_API.SITE_SECTIONS_QUESTIONS_REORDER.replace(":sectionid", sectionId);

  return axios.post(url, orderObj);
};

const saveOrderForSiteFields = ({ siteId, orderObj }) => {
  let url = REST_API.SITE_FIELDS_REORDER.replace(":siteid", siteId);
  // console.log(url);

  return executeRestApi(url, "post", orderObj);
};

const saveOrderForSiteLinks = ({ siteId, orderObj }) => {
  let url = REST_API.SITE_LINKS_REORDER.replace(":siteid", siteId);
  // console.log(url);

  return executeRestApi(url, "post", orderObj);
};

const getTopTenSubmissions = (fromDate, toDate) => {
  const params = new URLSearchParams({
    fromDate,
    toDate,
  });

  const url = REST_API.GLOBAL_REPORT_DASHBOARD + `/top?${params.toString()}`;
  return executeRestApi(url, "get");
};

const getDemographicsData = (siteName) => {
  let url = REST_API.GLOBAL_REPORT_DASHBOARD + "/" + siteName + "/demographics";
  return executeRestApi(url, "get");
};

const getMaturityScoreData = (siteName) => {
  let url = REST_API.GLOBAL_REPORT_DASHBOARD + "/" + siteName + "/average-maturity";
  return executeRestApi(url, "get");
};

const getSitesDataForUsers = (userId) => {
  let url = REST_API.SITES + "/sites-for-user/" + userId;
  return executeRestApi(url, "get");
};

const getAllScoreRanges = () => {
  let url = REST_API.SCORE_RANGE;
  return executeRestApi(url, "get");
};

const getScoreRangesById = (id) => {
  let url = REST_API.SCORE_RANGE + "/" + id;
  return executeRestApi(url, "get");
};

const createScoreRanges = (data) => {
  let url = REST_API.SCORE_RANGE;
  return executeRestApi(url, "post", data);
};

const updateScoreRanges = (id, data) => {
  let url = REST_API.SCORE_RANGE + "/" + id;
  return executeRestApi(url, "put", data);
};

const deleteScoreRanges = (id) => {
  let url = REST_API.SCORE_RANGE + "/" + id;
  return executeRestApi(url, "delete");
};

const BADGE_TYPES = {
  phone: {
    label: "Phone",
    formInputType: "text",
  },
  address: {
    label: "Address",
    formInputType: "textarea",
  },
  url: {
    label: "URL",
    formInputType: "text",
  },
  email: {
    label: "EMail",
    formInputType: "text",
  },
};

const REGIONS = {
  aviation: "Aviation",
  maritime: "Maritime",
  greaterchina: "Greater China",
  anz: "ANZ",
  centraleurope: "Central Europe",
  northasia: "North Asia",
  northerneurope: "Northern Europe",
  singapore: "Singapore",
  southerneurope: "Southern Europe",
  northamericah3s: "North America H3S",
  africa: "Africa",
  eme: "EME",
  latam: "LATAM",
  canadamsbl: "Canada MSBL",
  pacific: "Pacific",
  sea: "SEA",
};

const PRONOUNS = {
  "": "Select",
  hehim: "He/Him",
  sheher: "She/Her",
  them: "Them",
};

const SALUTATION = {
  "": "Select",
  dr: "Dr.",
  mr: "Mr.",
  mrs: "Mrs.",
  ms: "Ms.",
};

const ROLES = [
  {
    "name": "Admin",
    "value": "ROLE_ADMIN"
  }, {
    "name": "Super Admin",
    "value": "ROLE_SUPER_ADMIN"
  }, {
    "name": "Moderator",
    "value": "ROLE_MODERATOR"
  }]

const FIELD_TYPE = [
  {
    "name": "Text Field",
    "value": "TEXTFIELD"
  }, {
    "name": "Picklist Dropdown",
    "value": "PICKLIST_DROPDOWN"
  }, {
    "name": "Checkbox Field",
    "value": "CHECKBOX"
  }
]

const QUESTION_TYPE = [
  {
    "name": "Checkbox Group",
    "value": "CHECKBOX_GROUP"
  }, {
    "name": "Picklist",
    "value": "PICKLIST"
  }, {
    "name": "Picklist Dropdown",
    "value": "PICKLIST_DROPDOWN"
  }, {
    "name": "Radio Button",
    "value": "RADIO"
  }
]

const LABEL_TYPE = [
  {
    "name": "Text",
    "value": "TEXT"
  }, {
    "name": "Image",
    "value": "IMAGE"
  },
  // {
  //   "name": "Ordered List",
  //   "value": "ORDERED_LIST"
  // }, {
  //   "name": "Unordered List",
  //   "value": "UNORDERED_LIST"
  // }
]

const LINK_TYPE = [
  {
    "name": "External",
    "value": "EXTERNAL"
  },
  {
    "name": "Internal",
    "value": "INTERNAL"
  },
  {
    "name": "Other",
    "value": "OTHER"
  }
]

const VIRTUAL_FOLDER_NAME = "root";

const APP_CLASS_NAMES = {
  disableStyle: "indi-disable-action-icon",
};

const isEmpty = (str) => !str || str.trim() === "";

const isValidUrl = (str) => {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
};

const Utils = {
  APP_CONSTANTS,
  REST_API,
  APP_URLS,
  APP_CLASS_NAMES,
  NAV_ITEMS_KEYS,
  NAV_ITEMS_VALUES,
  SITE_NAV_ITEMS_KEYS,
  SITE_NAV_ITEMS_VALUES,
  PROJECT_SITE_NAV_ITEMS_VALUES,
  ADMIN_PAGE_ROUTING_VARIABLE,
  BADGE_TYPES,
  REGIONS,
  PRONOUNS,
  SALUTATION,
  ROLES,
  FIELD_TYPE,
  QUESTION_TYPE,
  LABEL_TYPE,
  LINK_TYPE,
  VIRTUAL_FOLDER_NAME,
  userSessionExists,
  setQuizSurveyMapValue,
  getQuizSurveyMapValue,
  setUpdatedViewMapValue,
  getUpdatedViewMapValue,
  getUserProfile,
  getAllUsers,
  getAllUserProfiles,
  bulkUsersUpload,
  addUser,
  editUser,
  createProfile,
  editMasterProfile,
  editProfile,
  deleteProfile,
  deleteUsers,
  resetPasswordUsers,
  executeUserResetPassword,
  getUserCardsList,
  deleteAddresses,
  getAddresses,
  addAddress,
  editAddress,
  bulkAddressUpload,
  getBadges,
  addBadge,
  editBadge,
  deleteBadges,
  getUserId,
  getFilteredUsers,
  getCardDetailsAsAnonymous,
  getAddressAsAnonymous,
  getCardDetails,
  validateCardFriendlyId,
  deleteCard,
  addNewTemplate,
  editTemplate,
  deleteTemplate,
  getTemplates,
  getTemplateDetails,
  getSiteDetailsbyId,
  executeLoginRESTAPI,
  executeLogoutRESTAPI,
  executeResetPassword,
  executeCardAddRESTAPI,
  executeCardEditRESTAPI,
  addOrRemoveCardFromUser,
  getUniqueSetOfArray,
  addBrand,
  getBrands,
  deleteBrands,
  createSession,
  deleteSession,
  isObjectEmpty,
  fileToDataUri,
  getImagePath,
  getStaticImagePath,
  getDomainName,
  cardMail,
  guestMail,
  downloadQRCode,
  getLanguages,
  handleDefaultError,
  getAllFolders,
  addFolder,
  editFolder,
  deleteFolder,
  getProjectSites,
  getAllSites,
  getRootLevelSites,
  getAllSitesForReport,
  cloneSite,
  updateSite,
  moveSites,
  deleteSites,
  getAllSections,
  addSection,
  updateSection,
  deleteSections,
  getAllFieldsBySitedId,
  addField,
  updateFieldById,
  deleteFields,
  getAllLabelsBySitedId,
  addLabel,
  updateLabel,
  deleteLabels,
  getIncompleteReportsBySiteId,
  getCompleteReportsBySiteId,
  getExportReportsBySiteId,
  getPdfReportById,
  saveOrderForSite,
  saveOrderForSiteFields,
  saveOrderForSiteLinks,
  getAllQuestions,
  addQuestion,
  updateQuestion,
  deleteQuestions,
  saveOrderForSection,
  getAllQuestionsForSite,
  getAllLinksBySitedId,
  addLink,
  updateLinkById,
  deleteLink,
  deleteLinks,
  isEmpty,
  isValidUrl,
  getTopTenSubmissions,
  getDemographicsData,
  getMaturityScoreData,
  getSitesDataForUsers,
  getAllScoreRanges,
  getScoreRangesById,
  createScoreRanges,
  updateScoreRanges,
  deleteScoreRanges
};

export default Utils;
